import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { DetailRouteProps } from "./routes-path";
import DetailHostovaniDlouhodobe, { DetailHostovaniDlouhodobeProps } from "common/components/evidence/clenove/hostovani-dlouhodoba/DetailHostovaniDlouhodobe";
import PageContent from "common/web/PageContent";

interface HostovaniDlouhodobaDetailProps {
    clenId: number;
}

type Props = HostovaniDlouhodobaDetailProps & RouteComponentProps<DetailRouteProps>;

class HostovaniDlouhodobaDetail extends React.PureComponent<Props> {

    render() {
        const { clenId } = this.props;
        const { hostovaniId } = this.props.match.params;

        const dpProps: DetailHostovaniDlouhodobeProps = {
            hostovaniId: Number(hostovaniId),
            clenId: clenId,
        }
        return <PageContent titles={['Hostování dlouhodobá', 'Detail hostování']}>
            <DetailHostovaniDlouhodobe {...dpProps} />
        </PageContent>
    }
}

export default withRouter(HostovaniDlouhodobaDetail);